import { createAction } from 'redux-actions'

import * as EmbedConstants from './constants'

export const receiveEmbed = (embed) => ({
  type: 'RECEIVE_EMBED_CONFIG',
  config: embed,
})

export const updateEmbed = createAction(EmbedConstants.UPDATE_EMBED)
